import React, { useState, useEffect } from "react";

import { motion } from "framer-motion";

import useDims from "../atoms/useDims";
import useCheckPC from "../atoms/useCheckPC";
import {
  activeSectionWidthRatios as rWidth,
  activeSectionHeightRatios as rHeight,
  TRANSITON_SPEED
} from "../../constants";

const getSection = current => {
  switch (current) {
    case "/":
      return "default";
    case "/works":
      return "work";
    case "/about":
      return "about";
    case "/teams":
      return "team";
    default:
      return "default";
  }
};

const Animated = ({ current, endpoint, children, ...props }) => {
  const isPC = useCheckPC();
  const { width } = useDims({ height: 0, width: 0 });
  const [section, setSection] = useState(getSection(current) || "default");
  useEffect(() => {
    if (section !== getSection(current)) {
      setSection(getSection(current));
    }
  }, [current]);

  const [init, setInit] = useState(true);
  const transition = init ? TRANSITON_SPEED.initial : TRANSITON_SPEED.default;
  const initVariants = {
    pc: {
      top: 0
    },
    mobile: {
      left: 0
    }
  };
  const variants = {
    // when work is active
    work: {
      // work divider is 66%
      work: {
        pc: { left: 0, top: 135, transition: transition },
        mobile: { top: 0, left: 0 }
      },
      // team divier is 83%
      team: {
        pc: {
          left: width * rWidth.work.work,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      },
      about: {
        pc: {
          left: width * rWidth.work.team,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      }
    },
    team: {
      work: {
        pc: { left: 0, top: 135, transition: transition },
        mobile: { top: 0, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.team.work,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      },
      about: {
        pc: {
          left: width * rWidth.team.team,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      }
    },
    about: {
      work: {
        pc: { left: 0, top: 135, transition: transition },
        mobile: { top: 0, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.about.work,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      },
      about: {
        pc: {
          left: width * rWidth.about.team,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      }
    },
    default: {
      work: {
        pc: { left: 0, top: 135, transition: transition },
        mobile: { top: 0, left: 0 }
      },
      team: {
        pc: {
          left: width * rWidth.default.work,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      },
      about: {
        pc: {
          left: width * rWidth.default.team,
          top: 135,
          transition: transition
        },
        mobile: { top: 0, left: 0 }
      }
    }
  };

  return (
    <motion.div
      {...props}
      initial={isPC ? initVariants.pc : initVariants.mobile}
      animate={
        variants[section][getSection(endpoint)] && isPC
          ? variants[section][getSection(endpoint)].pc
          : variants[section][getSection(endpoint)].mobile
      }
      onAnimationComplete={() => setInit(false)}
    >
      {children}
    </motion.div>
  );
};

export default Animated;
